import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../../services/event-emitter";

class HowToVideo extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.eventemitter.on("how-to-videos-modal-show", this.show);
  }

  componentWillUnmount() {
    this.eventemitter.off("how-to-videos-modal-show", this.show);
  }

  show = () => {
    this.setState({
      show: true
    });
  };

  hide = () => {
    this.setState({
      show: false
    });
  };

  render() {
    const { url = "" } = this.props;
    const { show } = this.state;

    if (url === "") {
      return null;
    }

    const iframeStyle = {
      width: "100%",
      height: "100%"
    };

    return (
      <Modal
        backdrop={true}
        dialogClassName="how-to-videos-modal"
        show={show}
        onHide={this.hide}
      >
        <Modal.Header closeButton={true} />
        <Modal.Body>
          <iframe src={url} style={iframeStyle} title="How To" />
        </Modal.Body>
      </Modal>
    );
  }
}

export default HowToVideo;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/modal/how-to-video.js